<template>
	<div id="app">
		<nav_header ></nav_header>
		<router-view />
	</div>
</template>

<script>
	import Vheader from '@/views/header'
	export default {
		name: 'App',
		data() {
			return {

			}
		},
		components:{
			nav_header:Vheader
		},
		created: function(){
      if(this.$route.path!='/login'&&this.$route.path!='/'){
        Vheader.methods.getCartItemsCount();
      }

		}
	}
</script>

<style>
	body {
		margin: 0;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		margin-top: 80px;
	}

	.main-content {
		background: #f0f0f0;
		min-height: calc(100vh - 80px);
		min-width: 1200px;
		/* 标准的语法（必须放在最后） */
	}

	/* 导航栏 */
	.indexNavOut {
		background-color: #000;
		height: 80px;
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		line-height: 80px;
		color: #fff;
		z-index: 10;
		min-width: 1000px;
		width: 100%;
	}
.indexNav{margin: 0 20px;}
	.navLi li {
		list-style-type: none;
		display: inline-block;
		margin-left: 20px;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.navLi {
		margin: 0;
	}

	ul li a,a {
		color: #fff;
		text-decoration: none;
	}
	.step-slider,
	.step-progress {
		display: inline-block;
	}

	.iconchangjiantou-you {
		margin: 0 10px;
	}

	.step-active {
		color: rgb(74, 144, 138);
	}

	.username {
		margin-left: 100px;
	}

	.change_password {
		color: rgba(255, 152, 0, 1);
		margin-left: 20px;
		cursor: pointer;
	}

	.order-table {
		display: flex;
		width: 100%;
		border-top: 1px solid #d9d9d9;
		align-items: center;
	}

	.table-heard {
		background: rgb(74, 144, 138);
		margin-bottom: 20px;
		color: #fff;
	}

	.order-th {
		flex: 1;
		padding: 10px;
		text-align: center;
	}

	.order-item {
		border: 1px solid #D9D9D9;
		margin-bottom: 20px;
		background: #fff;
	}

	.order-info {
		background-color: #e9e9e9;
		padding: 10px 0;
	}

	.order-th {
		flex: 1;
		padding: 10px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue